import "./Navbar.css";
import ProfileIcon from "../ProfileIcon/ProfileIcon";
import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined';
import Badge from '@mui/material/Badge';
import LangugageSelector from "../LanguageSelector/LanguageSelector";
import ToogleThemeIcon from "../ToogleThemeIcon/ToogleThemeIcon";
import NotificationBar from "../NotificationBar/NotificationBar";

const NavBar = () => {
    return (
        <div className="navbar-container">
            {/* notification */}
            <NotificationBar />

            <div className="navbar px-[10px] flex items-center justify-end">
                <div className="language-selector mr-5">
                    <LangugageSelector styleProp = {{ border : 'none', background: 'transparent', color: 'var(--icons-color)' }} />
                </div>

                <ToogleThemeIcon />

                <div className="icons-color mr-6 cursor-pointer">
                    <Badge badgeContent={4} color="primary">
                        <NotificationsNoneOutlined />
                    </Badge>
                </div>

                <ProfileIcon />
            </div>
        </div>
    )
}

export default NavBar;